import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const postAddress = async (data) => {
  try {
    return await postData(`/useraddress/add`, data);
  } catch (error) {
    console.log(error);
  }
};

export const getAddress = async () => {
  try {
    return await getData(`/useraddress/show`);
  } catch (error) {
    console.log(error);
  }
};

export const getSingleAddress = async (id) => {
  try {
    return await getData(`/useraddress/show/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const DeleteAddress = async (id) => {
  try {
    return await postData(`/useraddress/delete/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const checkOutAfterPayment = async (id, data) => {
  try {
    return await postData(`/useraddress/order/payment-online/${id}`, data);
  } catch (error) {
    console.log(error);
  }
};

export const checkOut = async (data) => {
  try {
    return await postData(`/useraddress/order`, data);
  } catch (error) {
    console.log(error);
  }
};

export const getCouponCode = async (code, amount, applyCoupons) => {
  try {
    return await getData(
      `/coupenCode/coupon-code?code=${code}&amount=${amount}&applyCoupons=${applyCoupons}`,
    );
  } catch (error) {
    // Capture the error message from the response
    const message = error || "Invalid Coupon";
    return { success: false, message };
  }
};

export const getCoupon = async () => {
  try {
    return await getData(`/coupenCode/coupon`);
  } catch (error) {
    // Capture the error message from the response
    const message = error || "Invalid Coupon";
    return { success: false, message };
  }
};

export const getAllCoupon = async () => {
  try {
    return await getData(`/without-login//home/coupons`);
  } catch (error) {
    // Capture the error message from the response
    const message = error || "Invalid Coupon";
    return { success: false, message };
  }
};

export const postCancelOrder = async (data) => {
  try {
    return await postData(`/useraddress/cancel-order`, data);
  } catch (error) {
    console.log(error);
  }
};
export const postReturnOrder = async (data) => {
  try {
    return await postData(`/useraddress/return-order`, data);
  } catch (error) {
    console.log(error);
  }
};
